var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bp-footer bg-tdays-dark"},[_c('div',{staticClass:"h3 text-center txt-white py-4"},[_vm._v("Die touriDays-Garantie inklusive aller benannten Leistungen ist automatisch in jedem Urlaubsangebot von touriDat enthalten - Ihr Kauf ist zu 100% sicher!")])])
}]

export { render, staticRenderFns }